/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { TextField } from "@mui/material";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Link, NavLink } from "react-router-dom";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { SelfBillTable } from "../../../..//Purchase/Management/components/PurchaseSelfBill/SelfBillTable";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
// import businessActions from "../../../../Admin/Home/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, storageRemoveItem, idNamingConversion } from '../../../../../helpers/utilities';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const PurchaseSelfBills = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { purchaseSelfBillDetails, loader } = useSelector(state => state.purchaseManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { productGstdetails } = useSelector(state => state.adminSetupReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const { history } = props;
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const [importVisible, setImportVisible] = useState(false);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supply Self Bill', history, 'Purchase')) {
                loadTasks();
                storageRemoveItem('purchaseView');
            }
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/self-bill/create`);
        }
    };

    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { or: [] };
        if (search !== '') {
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ phone: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ billStatus: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'purchaseSelfBill',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.PURCHASE_SELFBILL_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'purchaseSelfBill',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props}
                closeLink={'/purchase'}
                img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supply Self Bill', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Supply Self Bill'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search SB No., Name, Ph. No., and Status'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'purchaseBill', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'purchaseBill', 'Link')}
                                                    onClick={() => { loadImportExportData('Purchaseselfbill'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'purchaseBill', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'create', 'Purchase') &&
                                                <Link
                                                    id={idNamingConversion('Create Debit Note', 'purchaseBill', 'Link')}
                                                    to={'/purchase/purchase-management/debit-note/create'}
                                                    // onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage, classes.padding10Left)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Debit Note</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'create', 'Purchase') &&
                                                <Link
                                                    id={idNamingConversion('Create Self Bill', 'purchaseBill', 'Link')}
                                                    to={'/purchase/purchase-management/self-bill/create'} className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Self Bill</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SelfBillTable
                                search={search}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                productGstdetails={productGstdetails}
                                businessDetails={businessDetails}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                roleManagement={roleManagement}
                                sortBy={sortBy}
                                sortOrder={sortOrder}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={'Supply Self Bill'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={purchaseSelfBillDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default PurchaseSelfBills